import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Worklist from "@/pages/Worklist";
import TaskExecute from "@/pages/TaskExecute";
import Verifications from "@/pages/Verifications";
import Masters from "@/pages/Masters";
import Checklists from "@/pages/Checklists";
import Reports from "@/pages/Reports";
import AuditLogs from "@/pages/AuditLogs";
import Users from "@/pages/Users";
import Roles from "@/pages/Roles";
import Settings from "@/pages/Settings";
import ScanArea from "@/pages/ScanArea";

function HomeRedirect() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "staff") return <Navigate to="/worklist" replace />;
  return <Dashboard />;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
                <Route path="/" element={<HomeRedirect />} />
                <Route path="/worklist" element={<ProtectedRoute roles={["staff", "admin", "supervisor"]}><Worklist /></ProtectedRoute>} />
                <Route path="/task/:id" element={<TaskExecute />} />
                <Route path="/scan" element={<ScanArea />} />
                <Route path="/verifications" element={<ProtectedRoute roles={["supervisor", "ops_manager", "admin"]}><Verifications /></ProtectedRoute>} />
                <Route path="/masters" element={<ProtectedRoute roles={["admin", "ops_manager"]}><Masters /></ProtectedRoute>} />
                <Route path="/checklists" element={<ProtectedRoute roles={["admin", "ops_manager"]}><Checklists /></ProtectedRoute>} />
                <Route path="/reports" element={<ProtectedRoute roles={["admin", "ops_manager", "auditor"]}><Reports /></ProtectedRoute>} />
                <Route path="/audit-logs" element={<ProtectedRoute roles={["admin", "auditor", "ops_manager"]}><AuditLogs /></ProtectedRoute>} />
                <Route path="/users" element={<ProtectedRoute roles={["admin"]}><Users /></ProtectedRoute>} />
                <Route path="/roles" element={<ProtectedRoute roles={["admin"]}><Roles /></ProtectedRoute>} />
                <Route path="/settings" element={<Settings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
